import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { useNavigation } from '@react-navigation/native';
import { useStoreActions, useStoreState } from '@/stores/store';
import { useCallback } from 'react';
import { Icon } from '@/components/Icon';
import { appTheme } from '@/config/colors';
import { SetCard } from '@/views/SetCard';
import { hasInternetAsync } from '@/screens/HomeTherapist/helpers';
import {
  Patient,
  SentenceSetFromApi,
  SetType,
  TextSetFromApi,
  WordSetFromApi,
} from '@/stores/store.types';
import { styles } from './styles';

const screenName = {
  Wörtersets: 'WordSet',
  Sätzesets: 'SentenceSet',
  Textesets: 'TextSet',
};

type SetProps = {
  type: SetType;
  data: (WordSetFromApi | SentenceSetFromApi | TextSetFromApi)[];
  patientID: string;
  fetchPatientsWrapper: () => void;
  selectedPatientFullName: string;
  patientsSyncing: (
    patientsParameter?: Patient[] | null,
    stackChanges?: boolean,
  ) => void;
  refreshPatient: () => void;
};

export const Set = ({
  type,
  data,
  patientID,
  fetchPatientsWrapper,
  selectedPatientFullName,
  patientsSyncing,
  refreshPatient,
}: SetProps) => {
  const { isTherapistDemo, toolTipNumber } = useStoreState((store) => store);
  const { setToolTipNumber, setGlobalPopupState } = useStoreActions(
    (action) => ({
      setToolTipNumber: action.setToolTipNumber,
      setGlobalPopupState: action.setGlobalPopupState,
    }),
  );

  const { navigate } = useNavigation();

  const handlePlusPress = useCallback(async () => {
    if (isTherapistDemo && toolTipNumber === 3) {
      setToolTipNumber(0);
    }
    const hasInternet = await hasInternetAsync();
    if (hasInternet) {
      return navigate(screenName[type], { selectedID: patientID });
    }
    setGlobalPopupState({
      headerText: 'Keine Verbindung zum neolexon Server',
      bodyText:
        'Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
      leftButton: '',
      rightButton: '',
    });
  }, [type, patientID, toolTipNumber]);

  return (
    <View style={styles.setItemStyle}>
      <View style={styles.container}>
        <View style={styles.headerContainer}>
          <Text style={styles.heading}>{type}</Text>
          <Pressable onPress={handlePlusPress}>
            <Icon name="plusCircle" color={appTheme.primary} size={30} />
          </Pressable>
        </View>
        {data?.length > 0 ? (
          <View style={styles.setContainer}>
            {data.map((eachData, index) => (
              <SetCard
                selectedPatientFullName={selectedPatientFullName}
                fetchPatientsWrapper={fetchPatientsWrapper}
                patientID={patientID}
                type={type}
                key={eachData._id}
                id={eachData._id}
                data={eachData}
                patientsSyncing={patientsSyncing}
                indexSetCard={index}
                refreshPatient={refreshPatient}
              />
            ))}
          </View>
        ) : (
          <Text>Noch keine {type} erstellt</Text>
        )}
      </View>
    </View>
  );
};
